import type { DocMeta } from './workspace-meta.js';

/**
 * A workspace's page list is a CRDT array, so the same doc id can end up in it
 * more than once. Every entry with the id describes the same doc: writes go to
 * all of them, and the doc counts as trashed when any of them is trashed.
 */
export function docMetaIndexes(
  docMetas: readonly DocMeta[],
  id: string
): number[] {
  const indexes: number[] = [];
  docMetas.forEach((meta, index) => {
    if (meta.id === id) indexes.push(index);
  });
  return indexes;
}

/**
 * The first entry with the id, reported as trashed when any entry with the id
 * is trashed.
 */
export function resolveDocMeta(
  docMetas: readonly DocMeta[],
  id: string
): DocMeta | undefined {
  const entries = docMetas.filter(meta => meta.id === id);
  const first = entries[0];
  if (!first || first.trash || !entries.some(meta => meta.trash)) {
    return first;
  }
  return { ...first, trash: true };
}
